import React, {useState} from "react";
import styles from "./ToolTip.module.scss";
import ArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import ArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';

const ToolTip = props => {
  const [toolTipVisible, setToolTipVisibility] = useState(false);

  return <div className={styles.toolTipContainer}>
      <div className={styles.toolTipAction} onClick={() => setToolTipVisibility(!toolTipVisible)}>
        <div className={styles.toolTipActionRow}>
          <div className={styles.toolTipActionColumnText}>
            <span id={props.id} name={props.name} className={styles.title}>{props.title}</span>
          </div>
         
        </div>
      </div>
      <div className={`${styles.tipContainer} ${toolTipVisible ? styles.tipContainerShow : styles.tipContainerHide}`}>
        <div className={styles.tip}>
          {props.text}
        </div>
      </div>
    
  </div>
}

export default ToolTip;